<template>
    <div>
        <div v-if="dashProfile && (dashProfile.isAdmin || dashProfile.isManager)">
            <div class="btn-group" role="group" style="margin-bottom: 15px; display: flex; justify-content: center;">
                <label style="margin-right: 10px; text-align: center;">
                    <input type="checkbox" v-model="criteria.field" :value="'sid'"> SID
                </label>
                <label style="text-align: center;">
                    <input type="checkbox" v-model="criteria.field" :value="'scode'"> SCODE
                </label>
            </div>
            <div class="input-group" style="margin-bottom: 20px;">
                <input type="text" class="form-control" placeholder="Value" name="" v-model="criteria.value">
                <div class="input-group-btn">
                    <span class="btn btn-primary" @click="onSearch()">{{ lang.search }}</span>
                    <span class="btn btn-default" @click="onSearchClear()"> {{lang.clear}} <span class="glyphicon glyphicon-remove"></span></span>
                </div>
            </div>
        </div>
        <div v-else>
            <span class="btn btn-primary" @click="loadItems()">{{lang.refresh}}</span>
        </div>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div class="row">
                
                <div v-for="shop in shops" class="col-xs-12 col-sm-6 col-md-4" style="margin-bottom: 20px;">
                    <div class="panel panel-default shop-card" style="transition: all 0.3s ease; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                        <div class="panel-body text-center" style="padding: 15px; background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);">
                            <div style="height: 120px; display: flex; align-items: center; justify-content: center;">
                                <img v-if="shop.logoPath!==null" class="img-responsive"
                                     :src="shop.logoPath"
                                     style="display:inline-block; max-height: 110px; max-width: 110px; border-radius: 10px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); transition: transform 0.3s ease;">
                                <div v-else style="height:110px; width: 110px; display:inline-block; border-radius: 10px; background: #e0e0e0; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);" class="pbcss-site-logo">
                                </div>
                            </div>
                        </div>
                        <div class="panel-footer text-center" style="background: rgba(251, 249, 249, 0.95); border-top: 1px solid #ddd; padding: 12px;">
                            <div style="margin-bottom: 8px; font-size: 12px; color: #666;">
                                <span class="label label-default" style="margin-right: 5px;">Code: {{shop.shopCode}}</span>
                                <span class="label label-default">State: {{shop.stateCode}}</span>
                                <span class="label label-info" v-if="shop.repShopId !==0" style="margin-left: 5px;">Agent</span>
                            </div>
                            <template v-if="isSelectMode===false">
                                <router-link :to="{path:'/ShopInfo',query:{shopUserId:shop.shopUserId}}">
                                    <span class="btn btn-primary btn-block" style="border-radius: 20px; font-weight: 500; transition: all 0.3s ease;"> {{shop.shopName}} / {{shop.domainName}}</span>
                                </router-link> 
                            </template>
                            <template v-else>
                                <span class="btn btn-success btn-block" @click="onSelect(shop)" style="border-radius: 20px; font-weight: 500; transition: all 0.3s ease;"> {{shop.shopName}} / {{shop.domainName}}</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </paged-loading>
    </div>


</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import apis from '../api/extApi.js';
    export default {
        components: {
            pagedLoading: pagedLoading
        },
        props:{
            isSelectMode:{type:Boolean,default:false}
        },
        computed: {
            dashProfile: function () {
                return this.$store.getters.dashProfile;
            },
            lang: function () {
                return this.$store.getters.lang.shopsList;
            }
        },
        data: function () {
            return {
                apiClient: apis.api,
                shops: [],
                paging: { page: 1, pageSize: 1, count: 1 },
                criteria: { value: null, field: [] },
                loadingImg: false
            };
        },
        methods: {
            onSearchClear: function () {
                this.criteria.field = null;
                this.criteria.value = null;
                this.onSearch();
            },
            onSearch: function () {
                var obj = { page: 1 };
                if (this.criteria.field && this.criteria.field.length > 0) {
                    obj[this.criteria.field[0]] = this.criteria.value;
                };
                this.loadItems(queryString().getString(obj));
            },
            onSelect: function (shop) {
                this.$emit('onselect', shop);
            },
            onPageChange: function (newPage) {
                var obj = { page: newPage };
                if (this.criteria.field && this.criteria.field.length > 0) {
                    obj[this.criteria.field[0]] = this.criteria.value;
                };
                this.loadItems(queryString().getString(obj));
            },
            // onSelect: function (file) {
            //     this.$emit('onselect', file);
            // },
            loadItems: function (query) {
                var that = this;
                this.loadingImg = true;
                this.apiClient.getShopListPrms(query).done(function (ret) {
                    that.loadingImg = false;
                    var filter = ret.value.filter;
                    that.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    that.shops = ret.value.items;
                });
            }
        },
        created: function () {
            this.loadItems();
        },
        mounted: function () {

        }
    }
</script>